<template>
<span>

  <b-dropdown right
              variant="link"
              no-caret>
    <template #button-content>
      <a class="data-table-action"
         v-b-tooltip.hover
         :title="$t('print')">
      <PrintSvg/><span class="action-button-mob-title">{{ $t('print') }}</span>
      </a>
    </template>
    <b-dropdown-item @click="print(1)">{{ $t('full') }}</b-dropdown-item>
    <b-dropdown-item @click="print(0)">{{ $t('simplified') }}</b-dropdown-item>
  </b-dropdown>

  <a class="data-table-action"
     v-if="canSendViaWhatsApp || canSendViaMax"
     v-b-tooltip.hover
     :title="$t('send_to_laboratory_via_messenger')">
      <b-dropdown right variant="link" no-caret>
        <template #button-content>
          <WhatsappSvg class="svg-light svg-size-lg"/><span class="action-button-mob-title">{{ $t('send_to_laboratory_via_messenger') }}</span>
        </template>
        <b-dropdown-header v-if="canSendViaWhatsApp">Whatsapp:</b-dropdown-header>
        <b-dropdown-item v-if="canSendViaWhatsApp" @click="print(1, true, 'Whatsapp')">{{ $t('full') }}</b-dropdown-item>
        <b-dropdown-item v-if="canSendViaWhatsApp" @click="print(0, true, 'Whatsapp')">{{ $t('simplified') }}</b-dropdown-item>
        <b-dropdown-divider v-if="canSendViaWhatsApp"/>
        <b-dropdown-header v-if="canSendViaWhatsApp">Telegram:</b-dropdown-header>
        <b-dropdown-item v-if="canSendViaWhatsApp" @click="print(1, true, 'Telegram')">{{ $t('full') }}</b-dropdown-item>
        <b-dropdown-item v-if="canSendViaWhatsApp" @click="print(0, true, 'Telegram')">{{ $t('simplified') }}</b-dropdown-item>
        <b-dropdown-divider v-if="canSendViaMax && canSendViaWhatsApp"/>
        <b-dropdown-header v-if="canSendViaMax">Max:</b-dropdown-header>
        <b-dropdown-item v-if="canSendViaMax" @click="print(1, true, 'Max')">{{ $t('full') }}</b-dropdown-item>
        <b-dropdown-item v-if="canSendViaMax" @click="print(0, true, 'Max')">{{ $t('simplified') }}</b-dropdown-item>
      </b-dropdown>
    </a>

  <a class="data-table-action"
     v-b-tooltip.hover
     v-if="object.status !== 'finished' && rights.includes('edit_laboratory_orders')"
     @click="changeStatus"
     :title="$t('change_status')">
      <StatusSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('change_status') }}</span>
    </a>
  <a class="data-table-action"
     :title="$t('edit')"
     v-if="object.status !== 'finished'"
     v-b-tooltip.hover
     @click="edit">
    <EditSvg class="svg-light"/>
    <span class="action-button-mob-title">{{ $t('edit') }}</span>
  </a>

  <a class="data-table-action"
     v-b-tooltip.hover
     v-if="route.name === 'LaboratoryPage' && rights.includes('edit_laboratory_orders')"
     @click="receivePayment"
     :title="$t('payment')">
      <DollarSvg/><span class="action-button-mob-title">{{ $t('payment') }}</span>
    </a>

  <a class="data-table-action"
     :title="$t('cancel_verb')"
     v-if="object.status === 'finished' && rights.includes('cancel_laboratory_orders')"
     v-b-tooltip.hover
     @click="restore">
    <RestoreSvg/>
    <span class="action-button-mob-title">{{ $t('cancel_verb') }}</span>
  </a>

  <b-modal id="order-status-modal"
           hide-footer
           :title="$t('status')"
           size="sm"
           v-if="showModal"
           centered>
    <a v-for="status in laboratoryOrderStatuses"
       class="d-flex justify-content-between align-items-center pointer py-2 text-black border-bottom visit-line"
       :key="`stage-${status.id}`"
       @click="saveStatus(status.id)">
      <span>{{ $t(status.title) }}</span>
      <span class="circle"
            :class="`status-${status.id}`"></span>
    </a>
  </b-modal>

    </span>
</template>

<script setup>
import EditSvg from '@/assets/svg-vue/general/edit.svg'
import JwtService from "@/services/jwt.service"
import {computed, getCurrentInstance, nextTick, onMounted, ref} from "vue"
import { useStore } from "vuex"
import PrintSvg from '@/assets/svg-vue/general/print2.svg'
import StatusSvg from '@/assets/svg-vue/general/approve_tr.svg'
import RestoreSvg from '@/assets/svg-vue/accounting/back.svg'
import {useRouter, useRoute } from "vue-router"
import {laboratoryOrderStatuses} from "@/dictionaries/dictionary"
import ApiService from "@/services/api.service"
import { EloquentService } from "@/services/api/eloquent.api.service"
import DollarSvg from "@/assets/svg-vue/accounting/dollar.svg.vue"
import WhatsappSvg from "@/assets/svg-vue/crm/whatsapp.svg.vue"

const props = defineProps({
  object: {
    type: Object
  }
})

const router = useRouter()
const route = useRoute()
const store = useStore()
const getters = store.getters

const showModal = ref(false)
const clinic = computed(() => store.state.auth.clinic)
const rights = computed(() => store.state.auth.rights)
const canSendViaWhatsApp = computed(() => getters.canSendViaWhatsApp && rights.value.includes('send_laboratory_order_to_messenger'))
const canSendViaMax = computed(() => getters.maxEnabled && rights.value.includes('send_laboratory_order_to_messenger'))

let bvModal = null
let i18n = null
let noty = null

onMounted(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
  i18n = instance?.ctx?.$i18n
  noty = instance?.appContext?.app?.noty
})

const print = async (full = 0, send = false, messenger = 'Whatsapp') => {
  let link = JwtService.getPrintPrelink(clinic.value)
  const url = link+'/requirement_order/'+props.object.id+'?full='+full
  if(!send) {
    window.open(url, '_blank')
  }
  if(send) {
    try {
      const res = await ApiService.get(`${url}&sendVia${messenger}=1`)
      const success = res?.data === 0
      if(success) {
        noty.info(i18n.t('sent'))
      } else {
        noty.error(i18n.t('error_message'))
      }
    } catch (e) {
      console.log(e)
    }
  }
}

const edit = () => {
  router.push(`/patients/${props.object.record.client_id}/visits/${props.object.record_id}/requirement_order`)
}

const changeStatus = async () => {
  showModal.value = true
  await nextTick()
  bvModal.show('order-status-modal')
}

const saveStatus = async (status) => {
  if(status === 'finished') {
    const isConfirmed = confirm(i18n.t('do_you_confirm_laboratory_order_finish2'))
    if(!isConfirmed) return;
  }
  try {
    let formData = new FormData()
    formData.append('status', status)
    await EloquentService.update('laboratory_order', props.object.id, formData)
    bvModal.hide('order-status-modal')
    store.commit('incrementDataTableCounter')
    setTimeout(() => {
      showModal.value = false
    }, 300)
  } catch (e) {
    console.log(e)
  }
}

const receivePayment = async () => {
  store.commit('setLaboratoryOrderId', props.object.id)
  await nextTick()
  bvModal.show('pay-lab-order-modal')
}

const restore = async () => {
  if(!confirm(i18n.t('do_you_confirm_cancel_laboratory_order'))) return
  await saveStatus('in_clinic')
}
</script>

<style scoped>
.data-table-action {
  cursor: pointer;
}
</style>
